module.exports = __webpack_public_path__ + "static/media/scroll_down.d5f8973d.svg";